import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsletterForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "" });
  const [errors, setErrors] = useState({});

  const submit = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!values.name || values.name.trim().length < 2) newErrors.name = t("newsletter.errors.name");
    if (!values.email || !emailRe.test(values.email)) newErrors.email = t("newsletter.errors.email");
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      navigate("/thank_you");
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      style={{
        background: "#fff",
        padding: "2.25rem",
        borderRadius: "6px",
        border: "1px solid var(--pum-gray-200)",
        boxShadow: "0 24px 60px -30px rgba(11,31,58,0.35)",
      }}
      noValidate
    >
      <div style={{ marginBottom: "1.25rem" }}>
        <span className="pum-eyebrow">{t("cta.eyebrow")}</span>
      </div>
      <h3 style={{ fontSize: "1.5rem", marginBottom: "0.75rem" }}>{t("newsletter.title")}</h3>
      <p style={{ color: "var(--pum-gray-700)", marginBottom: "1.5rem", fontSize: "0.95rem" }}>
        {t("newsletter.subtitle")}
      </p>

      <div style={{ marginBottom: "1rem" }}>
        <label className="pum-label" htmlFor="nl-name">{t("newsletter.nameLabel")}</label>
        <input
          id="nl-name"
          type="text"
          className="pum-input"
          placeholder={t("newsletter.namePlaceholder")}
          value={values.name}
          onChange={(e) => setValues((v) => ({ ...v, name: e.target.value }))}
          data-testid="newsletter-name-input"
        />
        {errors.name && <div className="pum-error" data-testid="newsletter-name-error">{errors.name}</div>}
      </div>

      <div style={{ marginBottom: "1.5rem" }}>
        <label className="pum-label" htmlFor="nl-email">{t("newsletter.emailLabel")}</label>
        <input
          id="nl-email"
          type="email"
          className="pum-input"
          placeholder={t("newsletter.emailPlaceholder")}
          value={values.email}
          onChange={(e) => setValues((v) => ({ ...v, email: e.target.value }))}
          data-testid="newsletter-email-input"
        />
        {errors.email && <div className="pum-error" data-testid="newsletter-email-error">{errors.email}</div>}
      </div>

      <button
        type="submit"
        className="pum-btn pum-btn--emerald"
        style={{ width: "100%", padding: "1.05rem", fontSize: "1rem" }}
        data-testid="newsletter-submit"
      >
        {t("newsletter.submit")}
        <ArrowRight size={18} />
      </button>

      <p style={{ marginTop: "1rem", fontSize: "0.78rem", color: "var(--pum-gray-500)", lineHeight: 1.5 }}>
        {t("newsletter.consent")}
      </p>
    </form>
  );
};

export default NewsletterForm;
